import { Icon, Text } from 'shared/components/ui';

import styles from './index.module.scss';

export const SidebarEmpty = () => {
	return (
		<div className={styles.sidebar}>
			<div className={styles.header}>
				<Text variant="inter/18/semi">Search Criteria</Text>
			</div>
			<div className={styles.filters}>
				<div className={styles.filtersIcon}>
					<Icon icon="checkmark" size={24} />
				</div>
				<div className={styles.column}>
					<Text variant="inter/15/semi">No skills selected</Text>
					<Text variant="inter/15/regular" color="grey">
						Finalize your technology selection to see skills appear here
					</Text>
				</div>
			</div>
			<div className={styles.footer}>
				<div className={styles.button}>
					<Text variant="inter/15/semi" color="grey">
						Continue to Filters
					</Text>
				</div>
			</div>
		</div>
	);
};
